// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputNumber_wrapper__Gv9y0"};